'use strict';
var fadeUpElements = document.querySelectorAll('.fade-up');
var observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.3
});
fadeUpElements.forEach(function(el) {
    return observer.observe(el);
});
document.addEventListener('DOMContentLoaded', function() {
    var initSwiper = function initSwiper() {
        var screenWidth = window.innerWidth;
        if (screenWidth <= 1024 && _$swiper === null) {
            var updatePagination = // eslint-disable-next-line no-inner-declarations
            function updatePagination(swiperInstance) {
                var current = document.querySelector('.swiper__pagination--current');
                var total = document.querySelector('.swiper__pagination--total');
                if (current && total) {
                    // eslint-disable-next-line max-len
                    current.textContent = String(swiperInstance.realIndex + 1).padStart(2, '0');
                    // eslint-disable-next-line max-len
                    total.textContent = String(swiperInstance.slides.length).padStart(2, '0');
                }
            };
            _$swiper = new Swiper('.features__wrapper', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                navigation: {
                    nextEl: '.swiper__button-next',
                    prevEl: '.swiper__button-prev'
                }
            });
            _$swiper.on('init slideChange', function() {
                return updatePagination(_$swiper);
            });
            _$swiper.init();
        }
        if (screenWidth > 1024 && _$swiper !== null) {
            _$swiper.destroy(true, true); // usuwa slider
            _$swiper = null;
        }
    };
    var _$swiper = null;
    initSwiper();
    window.addEventListener('resize', initSwiper);
});
if (window.innerWidth > 1024 && swiper !== null) {
    swiper.destroy(true, true);
    swiper = null;
    document.querySelectorAll('.swiper-slide').forEach(function(slide) {
        slide.style.width = '';
        slide.style.flex = '';
    });
    var wrapper = document.querySelector('.swiper-wrapper');
    if (wrapper) wrapper.style.display = '';
}

//# sourceMappingURL=Kickstarter.d1f40df9.js.map
